import { Modal } from 'reactstrap';
import { Link } from 'react-router-dom';

const ModalNoAccess = ({ isShow, onClose }) => {
  let title = 'You do not have access to this area';
  let description = 'Please, get in touch with an admin on your team to access permissions.';

  return (
    <Modal
      className="modal-dialog-centered modal-danger"
      contentClassName="bg-gradient-danger"
      isOpen={isShow}
      toggle={onClose}
      backdrop="static"
      keyboard={false}>
      <div className="modal-header justify-content-center">
        <h6 className="modal-title">{title}</h6>
      </div>
      <div className="modal-body">
        <div className="py-3 text-center">
          <i className="ni ni-bell-55 ni-3x" />
          <p>{description}</p>
        </div>
      </div>
      <div className="modal-footer">
        <Link to="/admin" className="text-white ml-auto mr-auto btn btn-link">
          Back to Dashboard
        </Link>
      </div>
    </Modal>
  );
};

export default ModalNoAccess;
